<!-- 訪問量 -->
<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">
                    <i class="fas fa-users mr-1"></i> 訪問量/瀏覽量
                </h3>
                <div class="card-tools">
                    <ul class="nav nav-pills ml-auto">
                        <li class="nav-item">
                            <a class="nav-link active" href="javascript:" @click="charts1Type = 0" data-toggle="tab">日</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="javascript:" @click="charts1Type = 1" data-toggle="tab">週</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="javascript:" @click="charts1Type = 2" data-toggle="tab">月</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="javascript:" @click="charts1Type = 3" data-toggle="tab">年</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="tab-content p-0">
                    <div class="chart" id="visitor-chart" style="position: relative; height: 300px">
                        <div id="visitor-chart-canvas" style="height: 300px"></div>
                    </div>
                </div>
            </div>
            <!-- /.card-body -->
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      charts2: null,
      charts1Type: 0,
      charts1Data: null,
    };
  },
  created() {
    this.getYestDay();
  },
  watch: {
    charts1Type(newV, oldV) {
      if (newV !== oldV) {
        this.setChart2();
      }
    },
  },
  methods: {
    getYestDay() {
      this.$api.permissionApi.getYestDayStatistics().then((rst) => {
        this.charts1Data = rst.data.result;
        this.setChart2();
      });
    },
    setChart2() {
      const id = "visitor-chart-canvas";
      if (!this.charts2) {
        this.charts2 = echarts.init(document.getElementById(id));
      }
      let xa = [];
      let TW_PV = [];
      let TW_TV = [];
      let HK_PV = [];
      let HK_TV = [];
      if (this.charts1Data) {
        let forData = null;
        if (this.charts1Type === 0) {
          forData = this.charts1Data.day;
        } else if (this.charts1Type === 1) {
          forData = this.charts1Data.week;
        } else if (this.charts1Type === 2) {
          forData = this.charts1Data.month;
        } else if (this.charts1Type === 3) {
          forData = this.charts1Data.year;
        }
        if (forData) {
          forData.forEach((element) => {
            xa.push(element.day);
            HK_PV.push(element.sgL_On_AHKCity || 0);
            HK_TV.push(element.sgL_On_AHKCity_TV || 0);
            TW_PV.push(element.sgL_On_ATWCity || 0);
            TW_TV.push(element.sgL_On_ATWCity_TV || 0);
          });
        }
        xa = [...new Set(xa)];
      }
      let legendData = ["香港訪問量", "香港瀏覽量","台灣訪問量", "台灣瀏覽量"];
      let StatisticsData=[HK_TV,HK_PV,TW_TV,TW_PV];
      console.log({StatisticsData});
      let seriesData=[];
      for(var i=0;i<legendData.length;i++){
        var series = {
            name: legendData[i],
            type: "line",
            // stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: StatisticsData[i],
        }
        seriesData.push(series);
      }
      console.log(seriesData);
      this.charts2.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: legendData,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            // boundaryGap: false,
            data: xa,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: seriesData,
      });
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.setChart2();
    });
  },
};
</script>


<style scoped>
.b-upload-task {
  font-size: 0.75rem;
}

.b-upload-task.table-striped tbody tr:nth-of-type(odd) {
  background: none;
}

.b-upload-task.table thead > tr > th:first-of-type,
.b-upload-task.table thead > tr > td:first-of-type,
.b-upload-task.table tbody > tr > th:first-of-type,
.b-upload-task.table tbody > tr > td:first-of-type {
  padding-left: 1rem !important;
}

.b-upload-task.table thead > tr > th:last-of-type,
.b-upload-task.table thead > tr > td:last-of-type,
.b-upload-task.table tbody > tr > th:last-of-type,
.b-upload-task.table tbody > tr > td:last-of-type {
  padding-right: 0.5rem !important;
}

.b-upload-task.table thead > tr:nth-of-type(even) > th:first-of-type,
.b-upload-task.table thead > tr:nth-of-type(even) > td:first-of-type,
.b-upload-task.table tbody > tr:nth-of-type(even) > th:first-of-type,
.b-upload-task.table tbody > tr:nth-of-type(even) > td:first-of-type {
  padding-left: 0.25rem !important;
}

.b-upload-task.table tr:nth-of-type(odd) td {
  padding-bottom: 0;
}

.b-upload-task.table tr:nth-of-type(even) td {
  border-top: 0;
  padding-top: 0;
}

.b-upload-task th,
.b-upload-task tr,
.b-upload-task td {
  padding: 0.25rem;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.b-upload-task .progress {
  height: 0.75rem;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/StatisticalChart/index.vue